@let items = items$ | async;
@let isLoading = isLoading$ | async;

<div
  class="listing"
  [ngClass]="{
    'no-filter-bar': !hasFilterSortBar,
    'with-playlists': contentType === ContentTypes.Playlist,
    'with-workouts': modeName === ModeNames.Workouts,
  }">
  @if (hasFilterSortBar) {
    <app-filter-sort-bar [modeName]="modeName" [isSearch]="isSearch" />
  }

  <div class="section">
    @if (!(isSearch && contentType !== ContentTypes.Playlist)) {
      <div class="section-title">
        @switch (modeName) {
          @case (ModeNames.Library) {
            @switch (contentType) {
              @case (ContentTypes.Video) {
                <span>
                  {{ 'browse.favorites.titles.myFavoriteVideos' | translate }}
                </span>
              }
              @case (ContentTypes.GpsTrack) {
                <span>
                  {{
                    'browse.favorites.titles.myFavoriteGpsTracks' | translate
                  }}
                </span>
              }
              @case (ContentTypes.Workout) {
                <span>
                  {{
                    'browse.favorites.titles.myFavoriteStructuredWorkouts'
                      | translate
                  }}
                </span>
              }
              @case (ContentTypes.Coaching) {
                <span>{{
                  'browse.favorites.titles.myFavoriteCoachings' | translate
                }}</span>
              }
              @case (ContentTypes.Playlist) {
                <span>{{
                  'browse.favorites.titles.myFavoritePlaylists' | translate
                }}</span>
              }
            }
          }
          @default {
            @switch (contentType) {
              @case (ContentTypes.Video) {
                <span>{{ 'browse.allVideos.title' | translate }}</span>
              }
              @case (ContentTypes.Playlist) {
                <span>{{ 'browse.playlists.title' | translate }}</span>
              }
              @case (ContentTypes.GpsTrack) {
                <span>{{ 'browse.gpsTracks' | translate }}</span>
              }
              @case (ContentTypes.Workout) {
                <span>{{
                  'browse.structuredTrainings.title' | translate
                }}</span>
              }
              @case (ContentTypes.Coaching) {
                <span>{{ 'browse.theCoaching' | translate }}</span>
              }
            }
          }
        }
      </div>
    }
    <app-pagination-container
      (displayMore)="onDisplayMore()"
      [isFull]="areItemsComplete$ | async"
      [isLoading]="isLoading"
      [useLoader]="contentType === ContentTypes.Playlist"
      [isPlaylist]="contentType === ContentTypes.Playlist">
      @if (items.length || isLoading) {
        <div class="cards-container">
          @for (item of items; track $index) {
            <div class="card-container" [title]="item.name">
              <div class="inner-card">
                @if (contentType === ContentTypes.Playlist) {
                  <kin-playlist-card
                    (onCardClick)="redirect($event, 'browse')"
                    [playlist]="item"
                    (onAuthorClick)="redirect(item.author.id, 'author')"
                    (onFavoriteClick)="onLikeClick(item)" />
                } @else {
                  <kin-scenic-card
                    (onCardClick)="redirect(item.id, 'browse')"
                    (onAuthorClick)="redirect(item.author.id, 'author')"
                    (onFavoriteClick)="onLikeClick(item)"
                    [information]="item"
                    [condensed]="item.type !== 'scenic'"
                    [size]="
                      (smallScreen$ | async) || (xSmallScreen$ | async)
                        ? 'small'
                        : 'medium'
                    "
                    [details]="true" />
                }
              </div>
            </div>
          }
          @if (isLoading && contentType !== ContentTypes.Playlist) {
            @for (item of [].constructor(4); track $index) {
              <div class="card-container">
                <div class="inner-card">
                  <kin-scenic-card
                    [loading]="true"
                    [size]="
                      (smallScreen$ | async) || (xSmallScreen$ | async)
                        ? 'small'
                        : 'medium'
                    " />
                </div>
              </div>
            }
          }
        </div>
      } @else {
        <ng-container>
          <div class="no-content">
            {{
              modeName === ModeNames.Library
                ? ('browse.favorites.noContentAvailableForThisMode' | translate)
                : ('browse.noContentAvailable' | translate)
            }}
          </div>
        </ng-container>
      }
    </app-pagination-container>
  </div>
</div>
